import { motion } from "framer-motion";
import CtaButton from "./CtaButton";

const Gallery = () => {
  return (
    <section className="bg-secondary py-20 md:py-28 px-6">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="text-xs tracking-[0.3em] uppercase text-warm-gray font-body">Gallery</span>
          <h2 className="mt-4 text-3xl md:text-4xl font-display font-light text-foreground">
            The Gallery
          </h2>
          <div className="mx-auto mt-6 h-px w-16 bg-champagne" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="overflow-hidden"
          >
            <img
              src="/gallery/love_otherwise-146.jpg"
              alt="Wedding gallery image"
              width={1440}
              height={960}
              loading="lazy"
              decoding="async"
              className="w-full h-[350px] md:h-[450px] object-cover hover:scale-105 transition-transform duration-700"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="overflow-hidden"
          >
            <img
              src="/gallery/love_otherwise-122.jpg"
              alt="Wedding gallery image"
              width={960}
              height={1440}
              loading="lazy"
              decoding="async"
              className="w-full h-[350px] md:h-[450px] object-cover hover:scale-105 transition-transform duration-700"
            />
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-center mt-10"
        >
          <CtaButton href="/gallery" variant="outline" onPinkBg>
            View Full Gallery
          </CtaButton>
        </motion.div>
      </div>
    </section>
  );
};

export default Gallery;
